export const SITE_ORIGIN = "https://trtplus.app";

export const ASSETS = {
    wordmark:
        "https://customer-assets.emergentagent.com/job_trt-plus-app/artifacts/mmm1ekmm_TRT%2B%20Text.png",
    icon: "https://customer-assets.emergentagent.com/job_trt-plus-app/artifacts/tb3zh5ao_icon.png",
    appCard:
        "https://customer-assets.emergentagent.com/job_trt-plus-app/artifacts/1suc9pc3_HeroNew.png",
    protocolScreen:
        "https://customer-assets-eiarnc6j.emergentagent.net/job_trt-plus-app/artifacts/2689bdf0c0eebd38_IMG_7720.webp",
    buildScreen:
        "https://customer-assets.emergentagent.com/job_trt-plus-app/artifacts/7mr0bxey_Screenshot%202026-04-29%20at%208.57.10%E2%80%AFam.png",
    formulaZakharov:
        "https://customer-assets.emergentagent.com/job_trt-plus-app/artifacts/rajj1e1z_Zakharov.png",
    formulaAERatio:
        "https://customer-assets.emergentagent.com/job_trt-plus-app/artifacts/11zz1lzp_AERatioFormula.png",
    formulaCream:
        "https://customer-assets.emergentagent.com/job_trt-plus-app/artifacts/gc1kwb43_CreamAbsorptionFormula.png",
    formulaMultiRoute:
        "https://customer-assets.emergentagent.com/job_trt-plus-app/artifacts/5mu191wm_MultiRoute.png",
    bloodworkScreen:
        "https://customer-assets-eiarnc6j.emergentagent.net/job_trt-plus-app/artifacts/da47827a71a9310a_IMG_7739.webp",
    testimatorScreen:
        "https://customer-assets-eiarnc6j.emergentagent.net/job_trt-plus-app/artifacts/ff3eeabad4140056_Testimator.webp",
};

export const LINKS = {
    appStore: "https://apps.apple.com/us/app/trt-plus/id6448075516",
    googlePlay:
        "https://play.google.com/store/apps/details?id=com.trtplus.app&hl=en_US",
    facebook: "https://m.facebook.com/trtplusapp",
    messenger: "https://m.me/trtplusapp",
    instagram: "https://m.instagram.com/trtplusapp/",
    email: "mailto:support@trtplus.app",
};
